import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
}
export function AccordionItem({
  question,
  answer
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-amber/20 last:border-none" data-id="element-141">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-5 flex justify-between items-center text-left focus:outline-none" data-id="element-142">
        <span className="font-serif text-lg md:text-xl font-medium text-charcoal pr-4" data-id="element-143">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="text-amber flex-shrink-0" data-id="element-144">
          <ChevronDown size={24} data-id="element-145" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-146">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-147">
            <div className="pb-5 text-charcoal-light font-sans leading-relaxed" data-id="element-148">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}